// App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

// Route-based code splitting: each page loads only when navigated to
const LoginPage = lazy(() => import('./components/LoginPage'));
const MainPage = lazy(() => import('./components/MainPage'));
const PublicMainPage = lazy(() => import('./components/PublicMainPage'));
const PublicView = lazy(() => import('./components/PublicView'));
const OtherConfig = lazy(() => import('./components/OtherConfig'));
const LLMPlayground = lazy(() => import('./components/LLMPlayground'));
const Eva=lazy(()=>import('./components/Evaload'))

// const LoadingFallback = () => (
//   <div style={{
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     background: 'var(--background-color, #1a1b2e)',
//     color: 'var(--text-color, #e0e0e0)',
//     fontFamily: '"Inter", "Segoe UI", sans-serif',
//     fontSize: '1.1rem',
//     letterSpacing: '0.5px'
//   }}>
//     <div style={{ textAlign: 'center' }}>
//       <div style={{
//         width: '40px',
//         height: '40px',
//         border: '3px solid rgba(255,255,255,0.1)',
//         borderTop: '3px solid var(--primary-color, #d580ff)',
//         borderRadius: '50%',
//         animation: 'spin 0.8s linear infinite',
//         margin: '0 auto 16px'
//       }} />
//       Loading...
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </div>
//   </div>
// );

const App = () => {
  return (
    <Router>
      {/* <Suspense fallback={<LoadingFallback />}> */}
      <Suspense fallback={<Eva />}>
        <Routes>
          <Route 
            path="/" 
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } 
          />
          <Route 
            path="/main" 
            element={
              <ProtectedRoute>
                <MainPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/config" 
            element={
              <ProtectedRoute>
                <OtherConfig />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/llm-playground" 
            element={
              <ProtectedRoute>
                <LLMPlayground />
              </ProtectedRoute>
            } 
          />
          <Route path="/public-main" element={<PublicMainPage />} />
          <Route path="/note/:noteId" element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          } />
          <Route path="/public/:noteId" element={<PublicView />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
